import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\navigation\\shared\\BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerTabs"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\PartnerTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeImage"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\SafeImage.tsx");
